import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-neutral-950 shadow-xl shadow-black/20' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/705391acbc6edace56d666e3d41c23dc.jpg" 
              alt="Nappy Rootz" 
              className="h-10 w-auto"
            />
            <span className="text-xl font-bold text-white">
              Nappy Rootz
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-sm font-semibold text-stone-300 hover:text-amber-500 transition-colors cursor-pointer">
              HOME
            </button>
            <button onClick={() => scrollToSection('services')} className="text-sm font-semibold text-stone-300 hover:text-amber-500 transition-colors cursor-pointer">
              SERVICES
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-sm font-semibold text-stone-300 hover:text-amber-500 transition-colors cursor-pointer">
              GALLERY
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-semibold text-stone-300 hover:text-amber-500 transition-colors cursor-pointer">
              CONTACT
            </button>
            <div className="flex items-center gap-6">
              <a href="tel:+18644499072" className="text-sm text-stone-400 hover:text-amber-500 transition-colors whitespace-nowrap flex items-center gap-2">
                <i className="ri-phone-line"></i>
                864.449.9072
              </a>
            </div>
            <div className="flex items-center gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-stone-400 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-stone-400 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
            </div>
            <button onClick={() => scrollToSection('book')} className="bg-gradient-to-r from-amber-600 to-amber-500 text-black px-6 py-2 rounded-full text-sm font-bold hover:from-amber-500 hover:to-amber-400 transition-all whitespace-nowrap cursor-pointer">
              BOOK NOW
            </button>
          </div>

          <button className="md:hidden">
            <i className="ri-menu-line text-2xl text-white"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
